import React, { useState } from 'react'
import { Products } from './Components/Products'
import Spinner from 'app/React/Components/misc/Spinner'
import { useStickyResult } from './useStickyResult'
import { useFilter } from './useFilter'
import { FilterHeaderMobile } from './Components/Filter/FilterHeaderMobile'
import { FilterResults } from './Components/Filter/FilterResults'
import clx from 'classnames'
import { FilterInner } from './Components/Filter/FilterInner'
import { useTranslation } from 'utils/useTranslation'
import { Pagination } from 'app/ProductShop/Components/Pagination'
import { useIsTablet } from 'app/ProductShop/Components/useIsTablet'

/**
 * @param {{
 * models_counts:{}[],
 * categories_counts:{}[],
 * accessories:any[],
 * total:number
 * }} props
 */
export function ProductShop(props) {
  const useAsModal = props.useAsModal ?? false
  const useWhiteFilterBackground = props.whiteFilterBackground ?? false
  const productSearchRestUrl = useTranslation('accessories_shop.rest_urls.products.search') ?? ''
  const [categorySet, setCategorySet] = useState(new Set())
  const [modelSet, setModelSet] = useState(new Set())
  const [page, setPage] = useState(1)
  const [isModelFilterOpen, setIsModelFilterOpen] = useState(false)
  const [isCategoryFilterOpen, setIsCategoryFilterOpen] = useState(false)

  const { data, loading } = useFilter(
    categorySet,
    modelSet,
    {
      data: {
        products: props.accessories,
        categories_counts: props.categories_counts,
        models_counts: props.models_counts,
        max_pages: props.max_pages,
        total: props.total,
        is_leasing: props.isLeasing,
        show_type: props.showType,
      }
    },
    productSearchRestUrl,
    page,
    useAsModal,
    useAsModal ? props.specificModelId : null,
    useAsModal ? props.specificVariantId : null,
    props.isLeasing,
    props.showType
  )

  const [showFilters, setShowFilters] = React.useState(false)

  const products = useStickyResult(data?.data?.products)
  const categoriesCounts = useStickyResult(data?.data?.categories_counts)
  const modelsCounts = useStickyResult(data?.data?.models_counts)
  const maxPages = useStickyResult(data?.data?.max_pages)
  const productCount = data?.data?.total

  const showModelFilter = !useAsModal
  const isTablet = useIsTablet()
  return (
    <div className={clx('mtt-product-shop', { 'use-as-modal': useAsModal })}>
      {props.children !== undefined ? props.children : null}
      <div className='page_container'>
        <div className='mtt-filter'>
          <FilterHeaderMobile
            showFilters={showFilters}
            setShowFilters={setShowFilters}
            setIsModelFilterOpen={setIsModelFilterOpen}
            setIsCategoryFilterOpen={setIsCategoryFilterOpen}
          />
          <FilterInner
            showFilters={showFilters}
            showModels={showModelFilter}
            productCount={productCount}
            modelsCounts={modelsCounts}
            modelSet={modelSet}
            setModelSet={setModelSet}
            isModelFilterOpen={isModelFilterOpen}
            setIsModelFilterOpen={setIsModelFilterOpen}
            categoriesCounts={categoriesCounts}
            categorySet={categorySet}
            setCategorySet={setCategorySet}
            isCategoryFilterOpen={isCategoryFilterOpen}
            setIsCategoryFilterOpen={setIsCategoryFilterOpen}
            setPage={setPage}
            whiteBackground={useWhiteFilterBackground}
          />
          <FilterResults
            productCount={productCount}
            isFiltered={categorySet.size + modelSet.size > 0}
            clearFilters={() => {
              setCategorySet(new Set())
              setModelSet(new Set())
            }}
            context={props.context}
          />
        </div>

        <div className='mtt-product-shop__content'>
          <div className='mtt-product-shop__inner'>{products ? <Products accessories={products} context={props.context} /> : null}</div>

          <div className='mtt-product-shop__bottom' style={{ zIndex: 999 }}>
            <Pagination maxPages={maxPages} currentPage={page} onClickChange={setPage} />
          </div>

          <div
            className={clx({
              'mtt-product-shop__spinner-container': isTablet ? false : loading,
              'mtt-product-shop__product-overlay': isTablet ? false : isCategoryFilterOpen || isModelFilterOpen
            })}
          >
            {loading ? <Spinner /> : null}
          </div>
        </div>
      </div>
    </div>
  )
}
